import styled from "styled-components";

import Box from "../Box";

const Text = styled(Box)({});

export default Text;
